export default __webpack_public_path__ + "static/assets/4a424430e50f215c651d02b387333b67.svg";